import React, { ReactElement } from "react";

export const header = [
  {
    key: "name",
    label: "Name",
    sortable: true,
    renderCallback: (row): ReactElement => (
      <a href="#" className="c-table__link">
        {row.name}
      </a>
    ),
  },
  {
    key: "client",
    label: "Client",
    sortable: true,
  },
  {
    key: "age",
    label: "Age",
    sortable: false,
  },
  {
    key: "hours",
    label: "Hours",
    sortable: true,
  },
];
